import { automaticApi, uriRefreshToken } from "../../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, put, PutEffect, SelectEffect, select } from "redux-saga/effects";
import { jwtDecode } from "jwt-decode";
import { setCustomer } from "@/redux/ducks/customer";
import { ReducersTypes } from "@/redux/reducers/Models";

export interface Fetch {
  callback: (success: boolean, code?: string) => void;
}

export interface RefreshAction {
  type: string;
  payload: Fetch;
}

const getCustomer = (state: ReducersTypes) => state.customerReducer;

export default function* refresh({
  payload,
}: RefreshAction): Generator<
  CallEffect<unknown> | PutEffect<Action> | SelectEffect,
  void,
  AxiosResponse
> {
  try {
    // @ts-expect-error
    const customer: ReducersTypes["customerReducer"] =
      yield select(getCustomer);

    const {
      NRC,
    }: {
      NRC: string;
    } = jwtDecode(customer?.refreshToken ?? customer?.refreshTokenTemporary!);

    const headers = {
      ...(!customer?.accessToken && {
        accesstoken: customer?.accessTokenTemporary,
        refreshtoken: customer?.refreshTokenTemporary,
        codigocliente: NRC,
      }),
    };

    const response: {
      data: {
        data: {
          accessToken: string;
          registredDevice: boolean;
        };
        status: {
          codigoRetorno: number | string;
          bloqueadoPorFraude?: boolean;
        };
      };
    } = yield call(automaticApi.post, uriRefreshToken, {}, { headers });
    const respondeData = response?.data;

    if (respondeData?.status?.codigoRetorno === 200) {
      yield put(
        setCustomer({
          accessToken: respondeData?.data?.accessToken,
          refreshToken: customer?.refreshTokenTemporary,
          accessTokenTemporary: undefined,
          refreshTokenTemporary: undefined,
        }),
      );
      yield call(payload.callback, true);
    } else {
      yield call(payload.callback, false, "error");
    }
  } catch (error) {
    yield call(payload.callback, false, "error");
  }
}
